import { checkUrlSafety } from '~/libs/external-redirect-lib'

export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path === from.path) {
    console.log('NUXT3 - BP Repo - Navigate to', to.path)
  } else {
    console.log('NUXT3 - BP Repo - Navigate to', to.path, 'from', from.path)
  }
  if (to.path === '/redirect-from-lendio') {
    const nuxtApp = useNuxtApp()
    try {
      // Pull the entire path after the first '?',
      const [, queryParamsString] = to.fullPath.match(/\?(.*)$/)
      // Get external_url property from the URL, additional query params and all
      const [, url] = queryParamsString.match(/external_url=(.+)/)

      // Convert the encoded characters back
      const decodedUrl = decodeURIComponent(url)

      const urlIsSafe = checkUrlSafety(decodedUrl)
      if (urlIsSafe) {
        return nuxtApp.runWithContext(() => navigateTo(decodedUrl, { external: true }))
      }

      console.log('going to: ', `/attempted-redirect?external_url=${decodedUrl}`)
      return nuxtApp.runWithContext(() => navigateTo(`/attempted-redirect?external_url=${decodedUrl}`))
    } catch (err) {
      log.warning("Failed to redirect a user visiting /redirect-from-lendio", { err })
    }
  }
})
